import React from 'react';
import Icon from '../../../components/AppIcon';

const IntegrationCard = ({ name, icon, iconColor, brands, status }) => {
  const isConnected = status === 'connected';

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 transition-base hover-lift hover:shadow-lg group">
      {/* Header with Icon and Status */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div
            className="w-12 h-12 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: `${iconColor}15` }}
          >
            <Icon name={icon} size={24} color={iconColor} strokeWidth={2} />
          </div>
          <div>
            <h3 className="text-h5 font-heading text-foreground">{name}</h3>
          </div>
        </div>

        {/* Status Badge */}
        <div
          className={`px-3 py-1 rounded-full text-xs font-medium flex items-center gap-1.5 ${
            isConnected
              ? 'bg-success/10 text-success' :'bg-error/10 text-error'
          }`}
        >
          <span className={`w-2 h-2 rounded-full ${
            isConnected ? 'bg-success' : 'bg-error'
          }`}></span>
          {isConnected ? 'Connected' : 'Not Connected'}
        </div>
      </div>

      {/* Brand Logos Section */}
      <div>
        <p className="text-xs text-muted-foreground mb-3 font-caption">Supported Platforms</p>
        <div className="flex flex-wrap gap-3">
          {brands?.map((brand, index) => {
            const brandConnected = brand.status === 'CONNECTED';
            return (
              <div
                key={index}
                className={`flex items-center gap-2 px-3 py-2 rounded-md transition-colors ${
                  brandConnected
                    ? 'bg-success/10 border border-success/20'
                    : 'bg-muted hover:bg-muted/70'
                }`}
              >
                <Icon
                  name={brand?.logo}
                  size={16}
                  color={brandConnected ? 'var(--color-success)' : 'var(--color-muted-foreground)'}
                  strokeWidth={2}
                />
                <span className={`text-xs font-medium ${
                  brandConnected ? 'text-success' : 'text-muted-foreground'
                }`}>
                  {brand?.name}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default IntegrationCard;
